import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=31819afb&scoped=true"
import script from "./battery.vue?vue&type=script&lang=ts"
export * from "./battery.vue?vue&type=script&lang=ts"
import style0 from "./battery.vue?vue&type=style&index=0&id=31819afb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31819afb",
  null
  
)

export default component.exports